import { useContext } from 'react';
import { ElementsContext } from '../contexts/ElementsContext';

function useElements() {
  const context = useContext(ElementsContext);
  if (!context) {
    throw new Error('Elements context should be used within ElementsContextProvider');
  }
  return context;
};

export default useElements;